import * as Preact from 'preact';
import * as Hooks from 'preact/hooks';
export var Component = function (props) {
    var canvasRef = Hooks.useRef();
    return (Preact.h("canvas", { style: { width: '100%', height: '100%', outline: 'none' }, ref: function (canvas) {
            if (canvas !== null &&
                (canvasRef.current === undefined || !canvasRef.current.isSameNode(canvas))) {
                canvasRef.current = canvas;
                props.onReady(canvasRef.current);
            }
        } }));
};
Component.displayName = 'Canvas';
